import  React, { memo } from 'react';
import { NavbarStyled } from '@geenee/builder/src/styles';

export const Navbar  = memo(() => (
    <NavbarStyled>
        <div />
    </NavbarStyled>
));
